import YahariReview from "./Articles/yahari-review";
import Shigatsu from "./Articles/Shigatsu"; // New article
import GiantKilling from "./Articles/GiantKilling"; // New article
import SpyXFamily from "./Articles/SpyXFamily"; // New article
import Haikyu from "./Articles/Haikyu"; // New article


const BlogData = [
    YahariReview,
    Shigatsu,
    GiantKilling,
    SpyXFamily,
    Haikyu,

  ];

export default BlogData;
